import type { DocMigration } from "../docMigration";
import { forEachFormula } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_21: DocMigration = {
  maxSchemaVersion: "0.0.21",
  apply(json: any) {
    const defaultLevelSettings = {
      firstCeilingHeight: 9,
      upperCeilingHeight: 9,
      floorPlateThickness: 12,
      firstWindowHeadHeight: 12,
      upperWindowHeadHeight: 12,
    };

    const {
      firstCeilingHeight,
      upperCeilingHeight,
      floorPlateThickness,
      firstWindowHeadHeight,
      upperWindowHeadHeight,
    } = {
      ...defaultLevelSettings,
      ...json.design?.partiParamValues,
    } as any;

    forEachFormula(json, (form) => {
      (form as any).formula = form.formula.replace("firstCeilingHeight", firstCeilingHeight.toString());
      (form as any).formula = form.formula.replace("upperCeilingHeight", upperCeilingHeight.toString());
      (form as any).formula = form.formula.replace("floorPlateThickness", floorPlateThickness.toString());
      (form as any).formula = form.formula.replace("firstWindowHeadHeight", firstWindowHeadHeight.toString());
      (form as any).formula = form.formula.replace("upperWindowHeadHeight", upperWindowHeadHeight.toString());
    });

    return json;
  },
};

export default migration_0_0_21;
